export default __webpack_public_path__ + "static/media/68b60ec769543b8c7c6797b54b5e40e0.svg";